import { render, staticRenderFns } from "./VpcList.vue?vue&type=template&id=0c2bc4d0"
import script from "./VpcList.vue?vue&type=script&lang=js"
export * from "./VpcList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports